module.exports = __webpack_public_path__ + "media/cartas-de-amor.4530ec8c.mp4";